const promises = {};



/*
  NOTE:

  This helper method allows us to pass in an ID (any helpful/unique name that makes sense) and
  any method that returns a promise like so:

  await sharedPromise('cleanTheDishes', () => {
    return http.post('/clean/the/dishes');
  });

  If the above code was executed rapidly many times in a row, our helper method makes sure that
  `http.post('/clean/the/dishes')` is only called a single time while the original promise is still
  pending. Once the original promise resolves or rejects, that result is shared and returned
  wherever our helper method was executed for that unique ID.
*/



function sharedPromise(id, method) {
  const existingPromise = promises[id];

  if (existingPromise) {
    return existingPromise;
  }

  const promise = new Promise((resolve, reject) => {
    method().then((result) => {
      delete promises[id];
      resolve(result);
    }).catch((error) => {
      delete promises[id];
      reject(error);
    });
  });

  promises[id] = promise;

  return promise;
}



export default sharedPromise;
